"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditAccountClient = void 0;
var tslib_1 = require("tslib");
var commerce_core_1 = require("@broadleaf/commerce-core");
var CreditAccountClient = /** @class */ (function (_super) {
    tslib_1.__extends(CreditAccountClient, _super);
    function CreditAccountClient(options) {
        return _super.call(this, tslib_1.__assign(tslib_1.__assign({}, options), { basePath: options.basePath || '/api/credit-account' })) || this;
    }
    /**
     * Sends a request to retrieve all the customer store credit accounts for the given customer id.
     *
     * @param customerId ID of the customer
     * @param options Additional request config details such as params and headers
     *
     * @returns All of the customer store credit accounts for the given customer id.
     */
    CreditAccountClient.prototype.fetchAllCustomerStoreCreditAccounts = function (customerId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = "/customers/" + customerId + "/store-credit-accounts";
                        config = {
                            method: 'get',
                            url: "" + uri
                        };
                        this.attachPageableParamsIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Attaches pageable params (size, sort, etc.) to the request `config` if present on `options`.
     *
     * @param config The axios request config to modify
     * @param options Options specifying additional parameters to be used to modify the `config`
     */
    CreditAccountClient.prototype.attachPageableParamsIfPresent = function (config, options) {
        if (options) {
            var page = options.page, size = options.size, sort = options.sort;
            if (page || page === 0) {
                config.params.page = page;
            }
            if (size || size === 0) {
                config.params.size = size;
            }
            if (sort) {
                config.params.sort = sort;
            }
        }
    };
    return CreditAccountClient;
}(commerce_core_1.AbstractClient));
exports.CreditAccountClient = CreditAccountClient;
//# sourceMappingURL=credit-account-client.js.map